var isclassadded = false;
if (window.innerWidth > 768) {
  let hasRun = false;

  document
    .querySelector(".header__icon-wrapper.tap-area.hidden-pocket.hidden-lap")
    ?.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent default link behavior

      if (!hasRun) {
        const searchDrawer = document.getElementById("search-drawer");
        if (searchDrawer) {
          searchDrawer.style.visibility = "visible";
          searchDrawer.style.transform = "translate(0)";

          setTimeout(() => {
            searchDrawer.setAttribute("open", "");
            // console.log("Open attribute set:", searchDrawer);
          }, 1100);

          setTimeout(() => {
            searchDrawer.style.visibility = "";
            searchDrawer.style.transform = "";
            // console.log("Styles removed:", searchDrawer);
          }, 1200);

          hasRun = true; // Prevent it from running again
        }
      }
    });
}

function isWizzyMobileSearchView() {
  return window.innerWidth < 1200;
}

function placeWizzyAutocomplete() {
  if (!document.body.classList.contains("wizzyMobileTapped")) return;
  const bar = document.querySelector("#search_mini_form .wizzy-search-form");
  if (!bar) return;
  const bottom = Math.round(bar.getBoundingClientRect().bottom);
  document.documentElement.style.setProperty("--wizzy-mobile-search-offset", bottom + "px");

  // Keep autocomplete inside the visible viewport when the keyboard is open
  const wrapper = document.querySelector(".wizzy-autocomplete-wrapper");
  if (!wrapper || !document.body.classList.contains("wizzy-mobile-typing")) return;
  if (window.visualViewport) {
    const available = Math.max(
      120,
      Math.round(window.visualViewport.height - bottom)
    );
    wrapper.style.maxHeight = available + "px";
    wrapper.style.bottom = "auto";
    wrapper.style.height = available + "px";
  }
}

function onWizzyMobileViewportChange() {
  if (!document.body.classList.contains("wizzyMobileTapped")) return;
  placeWizzyAutocomplete();
}

function bindWizzyMobileViewport() {
  if (window.__wizzyMobileViewportBound || !window.visualViewport) return;
  window.__wizzyMobileViewportBound = true;
  window.visualViewport.addEventListener("resize", onWizzyMobileViewportChange);
  window.visualViewport.addEventListener("scroll", onWizzyMobileViewportChange);
}

function clearWizzyMobileScrollLockStyles() {
  // Remove only scroll-lock inline styles — do not force overflow:auto (theme drawers need their own)
  ["overflow", "position", "top", "left", "right", "width", "height"].forEach(function (prop) {
    document.body.style.removeProperty(prop);
    document.documentElement.style.removeProperty(prop);
  });
}

function hideWizzyMobileAutocomplete() {
  // Close autocomplete only when mobile search template closes — not while typing
  document.querySelectorAll(".wizzy-autocomplete-wrapper").forEach(function (el) {
    el.style.setProperty("display", "none", "important");
    el.style.removeProperty("max-height");
    el.style.removeProperty("height");
    el.style.removeProperty("bottom");
  });
  document.body.classList.remove("wizzy-autocomplete-open");
  document.documentElement.classList.remove("wizzy-autocomplete-open");
}

var wizzyMobileMenuClickGuardUntil = 0;

function openWizzyMobileSearch(event) {
  if (!isWizzyMobileSearchView()) return false;
  const form = document.querySelector("#search_mini_form");
  const input = document.querySelector("#searchInput");
  if (!form || !input) return false;
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }
  // Block ghost click from landing on Curated/new-sarees banner after open
  wizzyMobileMenuClickGuardUntil = Date.now() + 450;
  // Scroll lock via CSS class only (no permanent inline overflow) so theme behaviour stays intact
  document.body.classList.add("wizzyMobileTapped");
  document.documentElement.classList.add("wizzyMobileTapped");
  bindWizzyMobileViewport();
  form.style.display = "block";
  form.querySelectorAll(".wizzy-search-form-wrapper, .wizzy-search-form").forEach(function (node) {
    node.classList.add("mobileTapped");
    node.style.display = "block";
  });
  // Let Wizzy show autocomplete again after a previous close
  document.querySelectorAll(".wizzy-autocomplete-wrapper").forEach(function (el) {
    el.style.removeProperty("display");
  });
  var isTyping = input.value.trim() !== "";
  form.classList.toggle("wizzy-mobile-search--typing", isTyping);
  document.body.classList.toggle("wizzy-mobile-typing", isTyping);
  if (!input.dataset.wizzyDefaultMenuBound) {
    input.dataset.wizzyDefaultMenuBound = "true";
    input.addEventListener("input", function () {
      // Typing only switches default menu ↔ autocomplete; does not close the template
      var typing = input.value.trim() !== "";
      form.classList.toggle("wizzy-mobile-search--typing", typing);
      document.body.classList.toggle("wizzy-mobile-typing", typing);
      placeWizzyAutocomplete();
    });
  }
  setTimeout(function () {
    input.click();
    input.focus();
    placeWizzyAutocomplete();
  }, 300);
  return true;
}

function closeWizzyMobileSearch() {
  const wasOpen = document.body.classList.contains("wizzyMobileTapped");
  const form = document.querySelector("#search_mini_form");
  const input = document.querySelector("#searchInput");
  if (input) {
    input.blur();
    input.value = "";
  }
  if (form) {
    form.style.display = "none";
    form.classList.remove("wizzy-mobile-search--typing");
    form.querySelectorAll(".wizzy-search-form-wrapper, .wizzy-search-form").forEach(function (node) {
      node.classList.remove("mobileTapped");
      node.style.display = "";
    });
  }
  document.body.classList.remove("wizzyMobileTapped");
  document.documentElement.classList.remove("wizzyMobileTapped");
  document.body.classList.remove("wizzy-mobile-typing");
  document.documentElement.style.removeProperty("--wizzy-mobile-search-offset");
  hideWizzyMobileAutocomplete();
  if (!wasOpen) return;

  // Unlock page for theme scroll; clear Wizzy leftover inline lock without setting overflow:auto
  clearWizzyMobileScrollLockStyles();
  // Wizzy may re-apply overflow:hidden after blur — clear again only if search stayed closed
  setTimeout(function () {
    if (document.body.classList.contains("wizzyMobileTapped")) return;
    if (
      document.body.classList.contains("wizzy-filters-overlay") ||
      document.body.classList.contains("wizzy-overlay-opened")
    ) {
      return;
    }
    clearWizzyMobileScrollLockStyles();
  }, 150);
}

function mobileHeaderSearchLink(target) {
  const link = target.closest(
    "a.header__icon-wrapper.tap-area.hidden-desk[aria-controls='search-drawer']"
  );
  if (link) return link;

  const icon = target.closest(".icon.icon--header-search");
  if (!icon) return null;
  const iconLink = icon.closest("a[aria-controls='search-drawer']");
  if (iconLink && iconLink.classList.contains("hidden-desk")) return iconLink;
  return null;
}

function closeThemeSearchDrawer() {
  const drawer = document.getElementById("search-drawer");
  if (drawer) {
    drawer.open = false;
    drawer.removeAttribute("open");
  }
  document
    .querySelectorAll("a.header__icon-wrapper.tap-area.hidden-desk[aria-controls='search-drawer']")
    .forEach(function (link) {
      link.setAttribute("aria-expanded", "false");
    });
}

function onMobileHeaderSearch(event) {
  if (!isWizzyMobileSearchView()) return;

  // Mobile-only: ignore accidental clicks on default-menu links until search UI is ready
  if (
    event.type === "click" &&
    Date.now() < wizzyMobileMenuClickGuardUntil &&
    event.target.closest("#search_mini_form a")
  ) {
    event.preventDefault();
    event.stopPropagation();
    return;
  }

  if (event.target.closest(".wizzy-search-back")) {
    event.preventDefault();
    event.stopPropagation();
    closeWizzyMobileSearch();
    return;
  }

  const link = mobileHeaderSearchLink(event.target);
  if (!link) return;

  // Open only on click (not pointerdown) so the same tap cannot hit the curated banner
  if (event.type !== "click") return;

  event.preventDefault();
  event.stopPropagation();
  if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  closeThemeSearchDrawer();
  openWizzyMobileSearch(event);
  setTimeout(closeThemeSearchDrawer, 0);
}

document.addEventListener("click", onMobileHeaderSearch, true);

// let timeCheckedTemplates = 0;

// const checkAndMoveDiv = setInterval(() => {
//   timeCheckedTemplates++;

//   if (moveTemplatesToBody()) {
//     clearInterval(checkAndMoveDiv);
//   }

//   if (timeCheckedTemplates === 10) {
//     clearInterval(checkAndMoveDiv);
//   }
// }, 10);
const observer = new MutationObserver(() => {
  document
    .querySelectorAll(
      '.product-item-image[src="https://cdn.shopify.com/s/images/themes/product-1_200x.png"]'
    )
    .forEach((img) => {
      img.style.width = "100%";
      img.style.height = "80%";
      // img.style.objectFit = "contain";
    });
});

observer.observe(document.body, { childList: true, subtree: true });

const refreshTriggers = ["/pages/search", "indiansilkhouseagencies.com/"];

function checkAndRefresh() {
  setTimeout(() => {
    const newURL = window.location.href;

    if (refreshTriggers.some((trigger) => newURL.includes(trigger))) {
      location.reload();
    }
  }, 1000);
}

// Detect Back/Forward button press
window.addEventListener("popstate", checkAndRefresh);

document
  .querySelectorAll(".header__icon-wrapper .icon--header-search")
  .forEach((ele) => {
    ele.addEventListener("click", function () {
      // console.log("Search bar clicked");
      let search = document.querySelector(".predictive-search__input");
      if (search) {
        search.focus();
      }
    });
  });

// document
//        .querySelector(".wizzy-autocomplete-wrapper.onLeft")
//        .forEach((element) => {
//          element.addEventListener("click", function () {
//            setTimeout(() => {
//              const autocompleteWrapper = document.querySelector(
//                ".wizzy-autocomplete-wrapper.onLeft"
//              );
//              if (autocompleteWrapper) {
//                autocompleteWrapper.style.display = "none";
//              }
//            }, 2000); // Hides after 2 seconds (2000ms)
//          });
//        });

document.addEventListener("DOMContentLoaded", function () {
  var mainDiv = document.getElementById("main");
  var searchWrapper = document.querySelector(".wizzy-search-wrapper");

  if (mainDiv && searchWrapper) {
    mainDiv.removeChild(searchWrapper); // Remove from #main
    document.body.appendChild(searchWrapper); // Append to <body>
  }
});

document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(
      ".wizzy-filters-facet-block.collapsible .wizzy-facet-head"
    )
    .forEach(function (facetHead) {
      facetHead.addEventListener("click", function () {
        this.parentElement.classList.toggle("active");
      });
    });
});
if (window.innerWidth > 768) {
  let elements = document.querySelectorAll(
    ".header__icon-wrapper.tap-area.hidden-pocket.hidden-lap"
  );
  elements.forEach((ele) => {
    // console.log("Adding event listener to:", ele);
    ele.addEventListener("click", function () {
      setTimeout(() => {
        let search = document.querySelector(".predictive-search__input");
        if (search) {
          search.click();
        } else {
          console.log(" ");
        }
      }, 500); // Adjust delay as needed
    });
  });
}


const colorMap = {
  "Aqua": "#00FFFF",
  Beach :"#F5DEB3",
  "Coral Pink":"#F88379",
  CREAM:"#FFFDD0",
  Green: "#008000",
  Blue: "#0000FF",
  Pink: "#FFC0CB",
  Multicolor: "#808080", // Approximation (varies)
  Cream: "#FFFDD0",
  Yellow: "#FFFF00",
  Red: "#FF0000",
  Purple: "#800080",
  Grey: "#808080",
  Black: "#000000",
  Orange: "#FFA500",
  White: "#FFFFFF",
  Maroon: "#800000",
  Peach: "#FFDAB9",
  Brown: "#A52A2A",
  Silver: "#C0C0C0",
  Wine: "#722F37",
  "Sea Green": "#2E8B57",
  "Pista Green": "#BEF574",
  Lavender: "#E6E6FA",
  "Sky Blue": "#87CEEB",
  Rama: "#3AB09E",
  Beige: "#F5F5DC",
  Violet: "#8A2BE2",
  Mustard: "#FFDB58",
  "Navy Blue": "#000080",
  Rani: "#FF007F",
  "Light Green": "#90EE90",
  Rust: "#B7410E",
  Teal: "#008080",
  Turquoise: "#40E0D0",
  Magenta: "#FF00FF",
  Golden: "#FFD700",
  Mehendi: "#669900",
  Firoza: "#00E3E3",
  "Olive Green": "#556B2F",
  "Baby Pink": "#F4C2C2",
  "Teal Green": "#006D5B",
  "Off White": "#FAF9F6",
  "Dark Green": "#006400",
  "Teal Blue": "#367588",
  "Bottle Green": "#006A4E",
  "Parrot Green": "#7FFFD4",
  "Light Pink": "#FFB6C1",
  Coffee: "#6F4E37",
  "Dark Pink": "#E75480",
  "Royal Blue": "#4169E1",
  Voilet: "#7F00FF",
  Burgundy: "#800020",
  Chiku: "#C19A6B",
};

function findHaxCode(key) {
  return colorMap.has(key) ? colorMap.get(key) : [key, !1];
}

function bindWizzySearchInput(data) {
  if (!data || !data.common) return;
  data.common.lazyDOMConfig = data.common.lazyDOMConfig || {};
  if (
    !Array.isArray(data.common.lazyDOMConfig.searchInputIdentifiers) ||
    !data.common.lazyDOMConfig.searchInputIdentifiers.length
  ) {
    data.common.lazyDOMConfig.searchInputIdentifiers = [{ dom: "", type: "text" }];
  }
  // Desktop: same as live — drawer input. Mobile: #searchInput form.
  if (window.innerWidth >= 1200) {
    data.common.lazyDOMConfig.searchInputIdentifiers[0] = {
      dom: ".drawer__header .predictive-search__input",
      type: "text",
    };
  } else {
    data.common.lazyDOMConfig.searchInputIdentifiers[0] = {
      dom: "#searchInput",
      type: "text",
    };
  }
}

function ensureWizzyDefaultMenu(config) {
  if (!config) return;
  config.autocomplete = config.autocomplete || {};
  config.autocomplete.configs = config.autocomplete.configs || {};
  if (!config.autocomplete.configs.defaultBehaviour) {
    config.autocomplete.configs.defaultBehaviour = {
      topProducts: {
        enabled: false,
        defaultPool: { method: "filters", data: {} },
      },
      suggestions: {
        enabled: true,
        displayTrending: false,
        displayRecent: false,
        defaultPool: [],
      },
    };
    return;
  }

  var behaviour = config.autocomplete.configs.defaultBehaviour;
  behaviour.topProducts = behaviour.topProducts || {};
  behaviour.suggestions = behaviour.suggestions || {};
  if (
    !behaviour.topProducts.enabled &&
    !behaviour.suggestions.enabled &&
    !behaviour.suggestions.displayTrending
  ) {
    behaviour.suggestions.enabled = true;
    behaviour.suggestions.defaultPool = behaviour.suggestions.defaultPool || [];
  }
}

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      facets = payload.response.payload.facets;
      for (let i = 0; i < facets.length; i++) {
        if (facets[i].key === "product_color_custom") {
          // console.log("facets_data", facets[i].data);
          facets[i].data.sort((a, b) => {
            let keyA = a.key.toUpperCase(); // Ignore case
            let keyB = b.key.toUpperCase(); // Ignore case
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
          });
        }
        if (facets[i].key === "product_value_tags_collection_tags") {

          // Sort facets[i].data alphabetically by the `key`
          facets[i].data.sort((a, b) => {
            let keyA = a.key.toUpperCase(); // Ignore case
            let keyB = b.key.toUpperCase(); // Ignore case
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
          });
        }

        if (facets[i].key === "product_product_type") {

          // Sort alphabetically by `key` (case-insensitive)
          facets[i].data.sort((a, b) => {
            let keyA = a.key.toUpperCase();
            let keyB = b.key.toUpperCase();
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
          });
        }

        if (window.wizzyConfig.common.categoryUrlKey === "saree-1") {
          if (facets[i].key === "product_value_tags_collection_all_sarees") {

            // Sort alphabetically by `key` (case-insensitive)
            facets[i].data.sort((a, b) => {
              let keyA = a.key.toUpperCase();
              let keyB = b.key.toUpperCase();
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });
          }

          if (facets[i].key === "product_value_tags_product_type_all_sarees") {
            facets[i].data.sort((a, b) => {
              let keyA = a.key.toUpperCase();
              let keyB = b.key.toUpperCase();
              return keyA.localeCompare(keyB);
            });
          }
        }
      }

      if (payload.api === "search" || payload.api === "filter") {
        var facets = payload.response.payload.facets;
        if (facets) {
          facets.forEach((facet) => {
            if (facet.key === "product_color_custom") {
              let facet_data = facet.data;
              if (facet_data) {
                facet_data.forEach((item) => {
                  let color = colorMap[item.label] || "#000000";
                  (item.isSwatch = !0),
                    (item.isURLSwatch = false),
                    (item.isVisualSwatch = !0),
                    (item.swatchValue = color),
                    (item.data = {
                      value: item.key,
                      swatch: {
                        type: "visual",
                        value: color,
                      },
                    });
                  item.code = color;
                });
              }
            }
          });
        }
      }
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      data.filters.attributeFacetValuesLimit = 50;

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      data.attributeFacetValuesLimit = 50;
      // Same as live drawer close — also close mobile search form before SLP render
      closeWizzyMobileSearch();
      document
        .querySelector(
          "predictive-search-drawer .drawer__header .drawer__close-button.tap-area"
        )
        ?.click();
      const Theircontent = document.querySelector(".icartShopifyCartContent");
      if (Theircontent) {
        Theircontent.style.display = "none";
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      document.querySelectorAll('.wizzy-facet-list-item').forEach((item) => {
  const count = item.querySelector('.wizzy-facet-list-item-count');
  if (count && count.innerText.trim() === "(0)") {
    item.style.display = "none";
  }
});

      const firstFilterBlock = document.querySelector(".wizzy-search-filters-left-wrapper .wizzy-facet-list-block .wizzy-filters-facet-block.facet-block-product_product_type");
      firstFilterBlock && firstFilterBlock.classList.contains("first-opened") && firstFilterBlock.classList.remove("collapsed");  

      window.currentURL = window.location.href;

      // Live category summary only — do not wipe SLP summary from the wrapper
      if (window.wizzyConfig.common.isOnCategoryPage) {
        const summaries = document.querySelectorAll(".wizzy-search-summary");

        if (summaries.length >= 0) {
          summaries.forEach((el, index) => {
            if (index >= 0) el.remove(); // Remove all except the first
          });
        }

        let mainContent = document.getElementById("main");
        let breadcrumb = document.querySelector(
          "title"
        );

        // Assuming `data.response.payload.total` contains the product count
        let productCount = data?.data?.response?.payload?.total || 0; // Default to 0 if not available
        let categoryName = breadcrumb
          ? breadcrumb.textContent.trim()
          : "Products";


        if (mainContent) {
        let summarywrapper = document.createElement("div");
        let summaryContainer = document.createElement("div");
        summaryContainer.className = "wizzy-search-summary-container";
        summarywrapper.className = "wizzy-search-summary";

        let li = document.createElement("li");
        li.className = "breadcrumb__item";

        let link = document.createElement("a");
        link.className = "breadcrumb__link";
        link.href = "/";
        link.textContent = "Home";

        li.appendChild(link);

        let slash = document.createElement("span");
        slash.textContent = " / ";

        let category = window.wizzyConfig?.common?.collectionHandle || "";
        let liCategory = document.createElement("li");
        liCategory.className = "breadcrumb__item";

        let spanCategory = document.createElement("span");
        spanCategory.className = "breadcrumb__link";
        spanCategory.textContent = category;

        liCategory.appendChild(spanCategory);

        summarywrapper.appendChild(summaryContainer);
        summarywrapper.appendChild(li);
        summarywrapper.appendChild(slash);
        summarywrapper.appendChild(liCategory);



          summaryContainer.innerHTML = `
          
            <p class="wizzy-summary-head">
                <span class="wizzy-summary-query">${categoryName}</span> (${productCount} products)
            </p>
        `;

          mainContent.insertBefore(summarywrapper, mainContent.firstChild);
        }
        let element = document.querySelector(
          ".wizzy-filters-facet-block.facet-block-categories.facet-block-left"
        );

        if (element) {
          element.style.display = "none";
        }
      }
      var filterCountElement = document.querySelector(
        ".wizzy-filters-mobile-entry .wz-active-filters-mobile-count"
      );
      var dotElement = document.querySelector(
        ".wizzy-search-results-wrapper .wizzy-filters-mobile-entry .wz-active-filters-add-dot"
      );

      if (filterCountElement && dotElement) {
        var count =
          parseInt(filterCountElement.textContent.replace(/\D/g, ""), 10) || 0; // Extract number
        if (count >= 1) {
          dotElement.classList.add("has-filters");
        } else {
          dotElement.classList.remove("has-filters");
        }
      }
      var facetItems_d = document.querySelectorAll(
        ".wizzy-facet-body .facet-body-product_product_type .wizzy-facet-list .wizzy-facet-list-item"
      );
      var filterCountElement = document.querySelector(
        ".wizzy-search-results-wrapper .wz-active-filters-add-dot"
      );

      if (facetItems_d.length > 0 && filterCountElement) {
        facetItems_d.forEach(function (item) {
          item.addEventListener("click", function () {
            filterCountElement.classList.add("has-filters");
          });
        });
      }

      if (
        window.innerWidth < 768 &&
        window.wizzyConfig.common.isOnCategoryPage
      ) {
        let selectedFilters = document.querySelector(
          ".wizzy-selected-filters-mobile"
        );
        if (selectedFilters) {
          setTimeout(() => {
            if (selectedFilters.querySelector(".wizzy-selected-facet-list")) {
              selectedFilters.style.display = "block";
            } else {
              selectedFilters.style.display = "none";
            }
          }, 100);
        }
        let elementfilter = document.querySelector(
          ".wizzy-search-wrapper .wizzy-search-results-wrapper .wizzy-search-filters-left .wizzy-search-filters-left-wrapper .wizzy-facet-list-block"
        );

        if (elementfilter) {
          elementfilter.style.margin = "24px 0px 0px 0px";
        }
      }
      const facetList1 = document.querySelector(".wizzy-selected-facet-list");
      const facetItems = facetList1 ? facetList1.querySelectorAll("li") : [];
      const filterEntry = document.querySelector(
        "a.wizzy-filters-mobile-entry"
      );

      if (facetItems.length > 0 && filterEntry) {
        filterEntry.classList.add("has-items");
      }

      const clearAllLink = document.querySelector(".wizzy-filters-clear-all");

      // Select the ul element and its list items
      const facetList = document.querySelector(".wizzy-selected-facet-list");
      const listItems = facetList ? facetList.querySelectorAll("li") : [];
      if (window.innerWidth < 768) {
        if (clearAllLink) {
          // Remove the anchor tag from the original div
          clearAllLink.parentNode.removeChild(clearAllLink);

          // Append only if there are more than one <li>
          if (listItems.length > 1) {
            const lastListItem = listItems[listItems.length - 1]; // Get the last <li>
            lastListItem.appendChild(clearAllLink);
          }
        }
      }

      if (window.innerWidth < 768) {
        var wizzySelectedFiltersInPannel = document.querySelector(
          ".wizzy-selected-filters-mobile"
        );
        var wizzySelectedFilters = document.querySelector(
          ".wizzy-selected-filters"
        );
        if (wizzySelectedFiltersInPannel && wizzySelectedFilters) {
          wizzySelectedFiltersInPannel.appendChild(wizzySelectedFilters);
        }
      }
      document
        .querySelector(".wizzy-common-select-label")
        .addEventListener("click", function () {
          var customSortHeading = document.querySelector(
            ".wizzy-custom-sort-heading"
          );
          var overlay = document.querySelector(".wizzy-common-select-overlay");
          var options = document.querySelector(".wizzy-common-select-options");

          // var isVisible = overlay.style.display === "block";
          // var newDisplay = isVisible ? "none" : "block";
          // console.log(newDisplay);
          // overlay.style.display = newDisplay;
          // options.style.display = newDisplay;

          // customSortHeading.style.display = isVisible ? "none" : "flex";
          // console.log("clicked", overlay.style.display);
          // console.log("clicked", options.style.display);
          // console.log("clicked", customSortHeading.style.display);

          const classes = [
            "wizzy-overlay-opened",
            "wizzy-common-select-body-overlay",
          ];

          if (
            document.documentElement.classList.contains(
              "wizzy-common-select-body-overlay"
            ) ||
            isclassadded
          ) {
            classes.forEach((cls) => {
              document.documentElement.classList.remove(cls);
              document.body.classList.remove(cls);
            });
            isclassadded = false;
          } else {
            classes.forEach((cls) => {
              document.documentElement.classList.add(cls);
              document.body.classList.add(cls);
            });
            isclassadded = true;
          }

          if (isclassadded) {
            overlay.style.display = "block";
            customSortHeading.style.display = "flex";
            options.style.display = "block";
          } else {
            overlay.style.display = "none";
            customSortHeading.style.display = "none";
            options.style.display = "none";
          }
        });

      document
        .querySelector(".wizzy-common-select-selector")
        .addEventListener("click", function () {
          var customSortHeading = document.querySelector(
            ".wizzy-custom-sort-heading"
          );
          var newDisplay =
            customSortHeading.style.display === "flex" ? "none" : "flex";

          customSortHeading.style.display = newDisplay;
        });

      document
        .querySelector(".wizzy-filters-close-button-block")
        .addEventListener("click", function () {
          var clearAllButton = document.querySelector(
            ".wizzy-filters-clear-all"
          );
          if (clearAllButton) {
            clearAllButton.click();
          }
        });

      document
        .querySelector(".wizzy-apply-all-button-block")
        .addEventListener("click", function () {
          var closeButton = document.querySelector(".wizzy-filters-close-btn");
          if (closeButton) {
            closeButton.click();
          }
        });
      document
        .querySelector(".th_wl_col_btn")
        .addEventListener("click", function () {
          window.addToWishlist(); // Call the window function
        });

      document
        .querySelectorAll(".wizzy-common-select-option")
        .forEach((option) => {
          option.addEventListener("click", function () {
            document
              .querySelectorAll(".wizzy-custom-sort-heading")
              .forEach((heading) => {
                heading.style.display = "none";
              });
          });
        });

      const observer = new MutationObserver(() => {
        const overlay = document.querySelector(".wizzy-common-select-overlay");
        const wishlistButtons = document.querySelectorAll(
          ".wizzy-search-wrapper .result-product-item-info .result-product-item-info-wishlist .th_wl_col_btn"
        );

        if (overlay && wishlistButtons.length > 0) {
          const overlayStyle = window.getComputedStyle(overlay);
          const zIndexValue = overlayStyle.display === "block" ? "0" : "10";

          wishlistButtons.forEach((btn) => {
            btn.style.zIndex = zIndexValue;
          });
        }
      });

      // Start observing changes in the document
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["style"],
      });

      document
        .querySelector(".wizzy-common-select-overlay")
        .addEventListener("click", function () {
          var customSortHeading = document.querySelector(
            ".wizzy-custom-sort-heading"
          );

          var newDisplayforheading =
            customSortHeading.style.display === "flex" ? "none" : "flex";

          customSortHeading.style.display = newDisplayforheading;
        });

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
      products.forEach((product) => {
        if (
          product.mainImage &&
          product.mainImage === "https://via.placeholder.com/360x360"
        ) {
          product.mainImage =
            "https://cdn.shopify.com/s/images/themes/product-1_200x.png";
        }
        product.attributes.forEach((attr) => {
          if (attr.id === "product_product_type") {
            let producttypename = attr.values[0].value[0];
            product.subtit = producttypename;
          }
          if(attr.id === "product___label_tags") {
            product.label = attr.values[0].value[0];
          }
          if (attr.id === "product_tags") {
            let tags = [];

            attr.values.forEach((item) => {
              if (item.value && item.value.length) {
                tags = tags.concat(item.value);
              }
            });

            // Split all comma-separated tags
            tags = tags.flatMap((tag) =>
              tag.split(",").map((tag) => tag.trim())
            );

            // Extract all __label: tags dynamically
            product.customLabels = tags
              .filter((tag) => tag.startsWith("__label:"))
              .map((tag) => tag.substring("__label:".length).trim());

          }
        });
      });

      return products;
    }
  );
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (data) {
          if ((window.wizzyConfig?.common?.isOnCategoryPage &&
    !data.response.payload.banners) || window.location.pathname === "/pages/search") {
      console.log("banners not there",window.wizzyConfig?.pageStore?.searchedResponse?.banners);
    const filters = window.wizzyConfig?.gridFilters?.filters;

    if (!Array.isArray(filters)) return;

    let counter = 6;

    filters.forEach(filter => {
      if (filter.after && typeof filter.after.web !== "undefined") {
        filter.after.web = counter;
        filter.after.mobile = counter;
        counter += 6;
      }
    });
  }

    return data;
    },3);
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
      data.gridFilters.enabled = true;
      if (data.common.isOnCategoryPage) {
        document.addEventListener("DOMContentLoaded", function () {
          let cartContent = document.querySelector(".icartShopifyCartContent");
          let mainElement = document.getElementById("main");

          if (cartContent && mainElement) {
            mainElement.insertBefore(cartContent, mainElement.firstChild);
          }
        });
      }

      data.common.lazyDOMConfig.contentDOMIdentifiers = ["#main"];
      bindWizzySearchInput(data);

      try{ 
      if (data.search?.configs?.facets?.configs) {
        data.search.view.templates.facets.rangeListItem = "#wizzy-facet-range-list-item";
        data.search.configs.facets.configs = data.search.configs.facets.configs.map((obj) => {
          if (obj.key === "sellingPrice") {
            obj.buckets = [
              { from: 0, to: 500 },
              { from: 500, to: 1000 },
              { from: 1001, to: 2000 },
              { from: 2001, to: 3000 },
              { from: 3001, to: 4000 },
              { from: 4001, to: 5000 },
              { from: 5001, to: 10000 },
              { from: 10000, to: 15000 },
              { from: 15000, to: 20000 },
              { from: 20000, to: 30000 },
              { from: 30000, to: 40000 },
              { from: 40000, to: 50000 },
              { from: 50000 },
            ];
          }
          return obj;
        });
      }
    }catch(e){
      console.log(e);
    }

      ensureWizzyDefaultMenu(data);
      return data;
    },1
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      document.querySelector("body").style.overflow = "auto";
      window.wizzyConfig.store.currency.symbol = "Rs.";
      bindWizzySearchInput(data);
      data.search.configs.facets.leftFacets.mobileCollapsible = true;
      data.filters.configs.keepOpenedInMobileAfterApply = !0;

      if (data.common.isOnCategoryPage) {
        document.addEventListener("DOMContentLoaded", function () {
          let cartContent = document.querySelector(".icartShopifyCartContent");
          let mainElement = document.getElementById("main");

          if (cartContent && mainElement) {
            mainElement.insertBefore(cartContent, mainElement.firstChild);
          }
        });
      }
      // else
      data.common.lazyDOMConfig.contentDOMIdentifiers = ["#main"];

      try{ 
      if (window.wizzyConfig?.search?.configs?.facets?.configs) {
        window.wizzyConfig.search.view.templates.facets.rangeListItem = "#wizzy-facet-range-list-item";
        window.wizzyConfig.search.configs.facets.configs = window.wizzyConfig.search.configs.facets.configs.map((obj) => {
          if (obj.key === "sellingPrice") {
            obj.buckets = [
              { from: 0, to: 500 },
              { from: 500, to: 1000 },
              { from: 1001, to: 2000 },
              { from: 2001, to: 3000 },
              { from: 3001, to: 4000 },
              { from: 4001, to: 5000 },
              { from: 5001, to: 10000 },
              { from: 10000, to: 15000 },
              { from: 15000, to: 20000 },
              { from: 20000, to: 30000 },
              { from: 30000, to: 40000 },
              { from: 40000, to: 50000 },
              { from: 50000 },
            ];
          }
          return obj;
        });
      }
    }catch(e){
      console.log(e);
    }

      ensureWizzyDefaultMenu(data);
      return data;
    },1
  );

};

let wizzyEvents = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      data.forEach((product) => {
        if (product.price) {
          if (product.price.endsWith(".00")) {
            product.price = product.price.slice(0, -3);
          }
        }
        if (product.sellingPrice) {
          if (product.sellingPrice.endsWith(".00")) {
            product.sellingPrice = product.sellingPrice.slice(0, -3);
          }
        }
        if (product.discount) {
          if (product.discount.endsWith(".00")) {
            product.discount = product.discount.slice(0, -3); // Remove the last three characters
          }
        }
      });
      return data;
    }
  );
};
window.onWizzyLoaded.push(wizzyEvents);
